import React from 'react';
const letterColors = {
  A: { bg: '#FFCDD2', color: '#C62828' },
  B: { bg: '#C8E6C9', color: '#2E7D32' },
  C: { bg: '#BBDEFB', color: '#1565C0' },
  D: { bg: '#D1C4E9', color: '#6A1B9A' },
  E: { bg: '#FFE0B2', color: '#EF6C00' },
  F: { bg: '#B2DFDB', color: '#00897B' },
  G: { bg: '#FFECB3', color: '#F9A825' },
  H: { bg: '#E1BEE7', color: '#8E24AA' },
  I: { bg: '#B3E5FC', color: '#039BE5' },
  J: { bg: '#DCEDC8', color: '#7CB342' },
  K: { bg: '#F8BBD0', color: '#D81B60' },
  L: { bg: '#D7CCC8', color: '#5D4037' },
  M: { bg: '#C5CAE9', color: '#303F9F' },
  N: { bg: '#FFF9C4', color: '#FBC02D' },
  O: { bg: '#E0F7FA', color: '#00ACC1' },
  P: { bg: '#F0F4C3', color: '#C0CA33' },
  Q: { bg: '#F3E5F5', color: '#9C27B0' },
  R: { bg: '#EDE7F6', color: '#512DA8' },
  S: { bg: '#FBE9E7', color: '#E64A19' },
  T: { bg: '#F9FBE7', color: '#AFB42B' },
  U: { bg: '#FFF3E0', color: '#FB8C00' },
  V: { bg: '#ECEFF1', color: '#546E7A' },
  W: { bg: '#E0F2F1', color: '#00796B' },
  X: { bg: '#FFCCBC', color: '#D84315' },
  Y: { bg: '#DCEDC8', color: '#558B2F' },
  Z: { bg: '#F1F8E9', color: '#33691E' },
};

const ProfileAvatar = () => {
  const firstName = localStorage.getItem('fname') || 'User';
  const firstLetter = firstName.charAt(0).toUpperCase();

  const { bg, color } = letterColors[firstLetter] || {
    bg: '#E0E0E0',
    color: '#424242',
  };

  return (
    <div
      style={{
        backgroundColor: bg,
        color: color,
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '22px',
        fontWeight: 'bold',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      }}
    >
      {firstLetter}
    </div>
  );
};

export default ProfileAvatar;